import React from 'react';
import {AppMenuItem} from '../../AppMenu/AppMenu';
import Designer from './Designer/Designer';
import EditorHeader from '../../AppHeader/EditorHeader';
import useProjectPriceObserver from '../../../Hooks/Project/useProjectPriceObserver';

export type GreetingCardProps = {
  onClickMenuItem: (item: AppMenuItem) => void;
};

const GreetingCard = ({onClickMenuItem}: GreetingCardProps) => {
  const projectPrice = useProjectPriceObserver();
  return (
    <>
      <EditorHeader onClickItem={onClickMenuItem} projectPrice={projectPrice} />
      <Designer />
    </>
  );
};

export default GreetingCard;
